<template>
  <div class="channelInfoColumn">
    <div class="headerRow">
      <div class="title">Kanal Bilgisi</div>
      <a class="closeBtn" @click="close">Kapat</a>
    </div>

    <div class="content" v-if="channel">
      <img v-if="channel.PhotoURL" :src="imageData" class="avatarImage" />
      <img v-else src="@/assets/images/groupdefault.png" class="avatarImage" />

      <div class="channelName">{{ channel.ChannelName }}</div>
      <div class="channelDescription" v-if="channel.ChannelDescription">
        {{ channel.ChannelDescription }}
      </div>
      <div class="metaRow">{{ participantLabel }}</div>
      <div class="metaRow" v-if="channel.Admins && channel.Admins.length > 0">
        Yöneticiler: {{ adminNames }}
      </div>
    </div>
  </div>
</template>

<script>
import { messageMixin } from '@/mixins/messageMixin.js'

export default {
  mixins: [messageMixin],

  data () {
    return {
      imageData: null
    }
  },

  computed: {
    channel () {
      return this.$store.state.conversation.activeConversation
    },

    participantLabel () {
      let count = this.channel && this.channel.ParticipantCount ? this.channel.ParticipantCount : 0
      return count + ' uye'
    },

    adminNames () {
      return (this.channel.Admins || [])
        .map(userId => {
          let user = this.$store.getters.getUserById(userId)
          return user && user.VisibleName ? user.VisibleName : userId
        })
        .join(', ')
    }
  },

  watch: {
    channel: {
      immediate: true,
      deep: true,
      handler (newValue) {
        if (!newValue || !newValue.PhotoURL) {
          this.imageData = null
          return
        }

        this.image(newValue.PhotoURL).then(value => {
          this.imageData = value
        })
      }
    }
  },

  methods: {
    close () {
      this.$store.state.display.rightSideColumn.isExpanded = false
    },

    image (url) {
      if (!url) {
        return Promise.resolve(null)
      }

      if (url.includes('http')) {
        return Promise.resolve(this.makeBlob(url, url))
      }

      let key = '6a61e395-b49a-4468-bee0-27644e95308f'
      let iv = key.split('').reverse().join('')
      let encryptedBody = this.ewk(url, key, iv)
      return Promise.resolve(this.makeBlob(process.env.VUE_APP_UPLOADURL2 + '/gfe?fn=' + url + '&s=' + encodeURIComponent(encryptedBody), url))
    }
  }
}
</script>

<style scoped>
.channelInfoColumn {
  height: 100%;
  padding: 20px;
  border-left: 1px solid rgb(223, 223, 223);
  background: white;
}

.headerRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.title {
  font-size: 18px;
  font-weight: 600;
}

.closeBtn {
  cursor: pointer;
  color: #5b7c99;
}

.content {
  text-align: center;
}

.avatarImage {
  width: 96px;
  height: 96px;
  border-radius: 48px;
  object-fit: cover;
}

.channelName {
  margin-top: 16px;
  font-size: 20px;
  font-weight: 600;
}

.channelDescription {
  margin-top: 8px;
  color: #666;
}

.metaRow {
  margin-top: 16px;
  color: #444;
  line-height: 1.5;
}
</style>
